import {createReducer} from '../../utils';

export default createReducer(null);
